module.exports = __webpack_public_path__ + "0d79c39f9716581195849a726c9fea1b.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio1/03_1MCA-Mutoflor.ogg
// module id = 773
// module chunks = 0